import { createFileRoute } from '@tanstack/react-router';
import Recruiting from '../../../../components/recruiting/Recruiting';

export const Route = createFileRoute(
  '/_authenticated/$owner/planning/$team_season_id/'
)({
  component: RouteComponent
});

function RouteComponent() {
  return <Recruiting status_type="planning" />;
}
